import configuration from "@utils/Config";
import { createEffect } from "effector";
import {
  restDeletionHandler,
  restDetailsHandler,
  restPostHandler,
} from "@utils/rest/RestClient";
import GroupSirensGetBodyDto from "@state/group/dto/body/group.sirens.get.body.dto";
import GroupAdminGetBodyDto from "@state/group/dto/body/group.admin.get.body.dto";
import {
  GroupMembership,
  GroupMembershipSearch,
  PageGroupMembership,
} from "@type/core/dashboard/dashboard.types";
import GroupMembershipAddBodyDto from "@state/group/dto/body/group.membership.add.body.dto";

const baseUrl = configuration.backendBaseUrl;
const groupSiren = baseUrl + "/ws/fo/groupSiren";
const groupAdmin = baseUrl + "/ws/fo/groupAdmin";
const groupMembership = baseUrl + "/ws/fo/groupMembership";
const searchGroupMembership = groupMembership + "/search";
const disable = "/disable";

export const requestGetGroupSirens = createEffect({
  handler: restDetailsHandler<GroupSirensGetBodyDto>(groupSiren),
});

export const requestGetGroupAdmin = createEffect({
  handler: restDetailsHandler<GroupAdminGetBodyDto>(groupAdmin),
});

export const requestSearchGroupMembership = createEffect({
  handler: restPostHandler<GroupMembershipSearch, PageGroupMembership>(
    searchGroupMembership,
  ),
});

export const requestPostGroupMembership = createEffect({
  handler: restPostHandler<GroupMembershipAddBodyDto, GroupMembership>(
    groupMembership,
  ),
});

export const requestDeleteGroupMembership = createEffect({
  handler: restDeletionHandler<void>(groupMembership),
});

export const requestPostDisableGroupMembership = createEffect({
  handler: restPostHandler<void, GroupMembership>(groupMembership, disable),
});
